var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 6.98104C1.66675 6.68911 1.66675 6.54314 1.67893 6.4202C1.79642 5.23441 2.73447 4.29635 3.92026 4.17887C4.0432 4.16669 4.19705 4.16669 4.50473 4.16669C4.62329 4.16669 4.68257 4.16669 4.7329 4.16364C5.37559 4.12472 5.93837 3.71908 6.17854 3.12169C6.19734 3.0749 6.21492 3.02216 6.25008 2.91669C6.28524 2.81121 6.30282 2.75847 6.32163 2.71169C6.56179 2.11429 7.12457 1.70866 7.76726 1.66974C7.81759 1.66669 7.87318 1.66669 7.98436 1.66669H12.0158C12.127 1.66669 12.1826 1.66669 12.2329 1.66974C12.8756 1.70866 13.4384 2.11429 13.6785 2.71169C13.6973 2.75847 13.7149 2.81121 13.7501 2.91669C13.7852 3.02216 13.8028 3.0749 13.8216 3.12169C14.0618 3.71908 14.6246 4.12472 15.2673 4.16364C15.3176 4.16669 15.3769 4.16669 15.4954 4.16669C15.8031 4.16669 15.957 4.16669 16.0799 4.17887C17.2657 4.29635 18.2037 5.23441 18.3212 6.4202C18.3334 6.54314 18.3334 6.68911 18.3334 6.98104V13.5C18.3334 14.9002 18.3334 15.6002 18.0609 16.135C17.8212 16.6054 17.4388 16.9879 16.9684 17.2275C16.4336 17.5 15.7335 17.5 14.3334 17.5H5.66675C4.26662 17.5 3.56655 17.5 3.03177 17.2275C2.56137 16.9879 2.17892 16.6054 1.93923 16.135C1.66675 15.6002 1.66675 14.9002 1.66675 13.5V6.98104Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.75C11.841 13.75 13.3334 12.2576 13.3334 10.4167C13.3334 8.57574 11.841 7.08335 10.0001 7.08335C8.15913 7.08335 6.66675 8.57574 6.66675 10.4167C6.66675 12.2576 8.15913 13.75 10.0001 13.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic_camera.5238a049b416093d8e9403ce2f6bae27.svg";
export { ForwardRef as ReactComponent };